export default __webpack_public_path__ + "static/media/btn_apply2.325d8121.gif";